export const printResponseProperty = (resProperty) => {
  if (!resProperty?.key || resProperty?.value === '') {
    return ''
  }

  if (resProperty.key === '_.score') {
    return 'Punteggio: ' + resProperty.value
  } else if (resProperty.key === '_.helper') {
    return 'Descrizione: ' + resProperty.value
  }

  return resProperty.key + ": " + resProperty.value
}

export const getPropertiesByValue = (options, value) => {
  return  options.find(opt => opt.value === value)?.properties || [];
}
